export default __webpack_public_path__ + "static/media/BTCST-BNB.11a85885.svg";